import { GroupedAccountCardItem, GroupedItems } from '../../../../models/account';

export const handleMove =
    (
        groupedItems: GroupedItems<GroupedAccountCardItem>,
        onChange: (items: GroupedItems<GroupedAccountCardItem>) => void,
        direction: 1 | -1,
    ) =>
    (account: GroupedAccountCardItem): boolean => {
        const group = groupedItems.find((group) => group.values.includes(account));

        if (!group) {
            return false;
        }

        const accountIndex = group.values.indexOf(account);
        const groupIndex = groupedItems.indexOf(group);

        const copied = [...groupedItems.map((item) => ({ ...item, values: [...item.values] }))];

        if (direction === -1) {
            if (groupIndex === 0 && accountIndex === 0) {
                return true;
            }

            if (accountIndex === 0) {
                copied[groupIndex - 1].values = [...copied[groupIndex - 1].values, { ...group.values[0] }];
                const { values } = copied[groupIndex];
                copied[groupIndex].values = [...values.slice(1, values.length)];
                onChange(copied);
                return false;
            }

            const { values } = copied[groupIndex];

            copied[groupIndex].values = [
                ...values.slice(0, accountIndex - 1),
                values[accountIndex],
                values[accountIndex - 1],
                ...values.slice(accountIndex + 1, values.length),
            ];

            onChange(copied);
            return false;
        }

        if (direction === 1) {
            if (groupIndex === groupedItems.length - 1 && accountIndex === group.values.length - 1) {
                return true;
            }

            if (accountIndex === group.values.length - 1) {
                copied[groupIndex + 1].values = [
                    { ...copied[groupIndex].values[accountIndex] },
                    ...copied[groupIndex + 1].values,
                ];
                const { values } = copied[groupIndex];
                copied[groupIndex].values = [...values.slice(0, values.length - 1)];
                onChange(copied);
                return false;
            }

            const { values } = copied[groupIndex];

            copied[groupIndex].values = [
                ...values.slice(0, accountIndex),
                values[accountIndex + 1],
                values[accountIndex],
                ...values.slice(accountIndex + 2, values.length),
            ];

            onChange(copied);
            return false;
        }

        return true;
    };
